<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>合作课程三级内容</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" class="user-search">

    <el-form-item  label="一级">
      <el-select size="small" v-model="type1" @change="selectOption1()" placeholder="请选择">
        <el-option v-for="type in typeArr1" :label="type.title" :value="type.id" :key="type.id"></el-option>
      </el-select>
    </el-form-item>

    <el-form-item  label="二级">
      <el-select size="small" v-model="type2" @change="selectOption2()" placeholder="请选择">
        <el-option v-for="type in typeArr2" :label="type.title" :value="type.id" :key="type.id"></el-option>
      </el-select>
    </el-form-item>

    <el-form-item  label="三级">
      <el-select size="small" v-model="type3" @change="selectOption3()" placeholder="请选择">
        <el-option v-for="type in typeArr3" :label="type.title" :value="type.id" :key="type.id"></el-option>
      </el-select>
    </el-form-item>





      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="getCourseClassifyList(this.type3)">查询</el-button>
      </el-form-item>

      <el-form-item label="">

        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
      style="width: 100%;">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>

      <el-table-column sortable prop="title" label="标题" width="200">
        </el-table-column>

        <el-table-column sortable prop="introduce" label="介绍" width="200">
        </el-table-column>
        <el-table-column sortable prop="titleOne" label="标签" width="200">
        </el-table-column>

        <el-table-column prop="name" label="封面图" width="120">
  
          <template slot-scope="scope">
            <img style="width: 90px;height: 90px;" :src="scope.row.coverPlan">
          </template>
  
        </el-table-column>


      <el-table-column sortable prop="createTime" label="创建时间" width="150">
      <template slot-scope="scope">
        <div>{{ transformDate(scope.row.createTime) }}</div>
      </template>
    </el-table-column>


      <el-table-column align="center" label="操作" min-width="300">
        <template slot-scope="scope">


          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">资料管理</el-button>
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" type="warning" @click="openMoveParent(scope.row, type3)">修改上级</el-button>
            <el-button size="mini" type="danger" @click="deleteCourseClassify(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" ref="editForm">
        <el-form-item label="标题" prop="deptName">
          <el-input size="small" v-model="formData.title" auto-complete="off" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="介绍" prop="deptName">
          <el-input size="small" v-model="formData.introduce" auto-complete="off" placeholder="请输入"></el-input>
        </el-form-item>

          <el-form-item label="标签" prop="deptName">
            <el-input size="small" v-model="formData.titleOne" auto-complete="off" placeholder="请输入"></el-input>
          </el-form-item>

          <el-form-item label="封面图" style="">
  
            <div class="upload-demo">
              <el-upload action="" :http-request="mainImgUpload" :show-file-list="false" list-type="picture-card">
                <i class="el-icon-plus"></i>
              </el-upload>
              <img v-if="formData.coverPlan" :src="formData.coverPlan" class="avatar">
  
            </div>
  
          </el-form-item>




      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="addCourseClassify()"
          v-if="title == '添加'">添加</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="upCourseClassify()"
          v-if="title == '修改'">修改</el-button>
      </div>
      </el-dialog>
      <el-dialog title="修改上级分类" :visible.sync="moveParentDialogVisible" width="460px" :close-on-click-modal="false">
        <el-form label-width="90px">
          <el-form-item label="上级分类">
            <el-cascader v-model="moveParentPath" :options="moveParentOptions" :props="moveParentProps" :disabled="moveParentSaving" filterable clearable placeholder="请选择上级分类" style="width: 100%;"></el-cascader>
          </el-form-item>
          <div style="color: #909399; line-height: 1.6;">当前分类：{{ moveParentRow && moveParentRow.title }}</div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="moveParentDialogVisible = false">取消</el-button>
          <el-button size="small" type="primary" :loading="moveParentSaving" @click="confirmMoveParent">确定修改</el-button>
        </div>
      </el-dialog>
  </div>
</template>

<script>
import {




  addCourseClassify,
  upCourseClassify,
  deleteCourseClassify,
  getCourseClassifyList,



} from "../../api/userMG";
import Pagination from "../../components/Pagination";
import client from "@/utils/ossClient.js";
import courseClassifyMove from "../../mixins/courseClassifyMove";
export default {
  mixins: [courseClassifyMove],
  data() {
    return {

    moveParentClassifyType: 1,
    moveParentDepth: 3,

    type1: 0,
    typeArr1: [ ],


    type2: 0,
    typeArr2: [],
    type3: 0,
    typeArr3: [],

      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: "添加",

      listData: [], //
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 10,
      },


      formData: {
        coverPlan: "",//封面图
        title: "",//标题     
        introduce: "",//介绍   
        difficultyLevel: "",//难度等级   
        superiorId: 0,//上级ID   
        level: 0,//分类等级     
        type: 2,// 0课程分类，1直播分类，2vip分类  
        titleOne: "",//二级标题     
        introduceOne: "",//二级介绍  

      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {

    
    this.getSuperiorCourseClassifyList(0,0)

  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    selectOption1(){

      this.getSuperiorCourseClassifyList(this.type1,1)
      
    },
    selectOption2(){

      this.getSuperiorCourseClassifyList(this.type2,2)
      
    },

   selectOption3(){

      this.getCourseClassifyList(this.type3)
      
    },

    // 按等级获取数据
    getSuperiorCourseClassifyList(superiorId,level) {
      this.loading = true;

      getCourseClassifyList({ type: 2, superiorId:superiorId,classifyType:1}).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          if (level==0) {

            this.typeArr2 = [];
            this.type2 = "";
            this.typeArr3 = [];
            this.type3 = "";
            this.listData = []
            //选择的第一级
            this.typeArr1 = res.data.list;
            this.type1 = this.typeArr1[0].id;







            this.getSuperiorCourseClassifyList(this.type1,1)
          }
          if (level==1) {

            this.typeArr3 = [];
            this.type3 = "";
            this.listData = []


            //选择的第二级
            this.typeArr2 = res.data.list;
            this.type2 = this.typeArr2[0].id;




            this.getSuperiorCourseClassifyList(this.type2,2)
          }
          if (level==2) {

            this.listData = []
            //选择的第三级
            this.typeArr3 = res.data.list;
            this.type3 = this.typeArr3[0].id;


            this.getCourseClassifyList(this.type3)
          }



          
        }else{
          this.typeArr2 = [];
            this.type2 = "";
            this.typeArr3 = [];
            this.type3 = "";



        }

      });
    },









    // 删除
    deleteCourseClassify(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteCourseClassify({ id: row.id })
            .then((res) => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: "已删除！",
                });
                this.getCourseClassifyList(this.type3);
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    //修改
    upCourseClassify() {

      this.loading = true;
      var formData = JSON.parse(JSON.stringify(this.formData));


      upCourseClassify(formData).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.editFormVisible = false
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.getCourseClassifyList(this.type3);
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    //添加分类
    addCourseClassify() {

      this.loading = true;

      var formData = JSON.parse(JSON.stringify(this.formData))




      addCourseClassify(this.formData).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.editFormVisible = false
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.getCourseClassifyList(this.type3);
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    //自定义上传方法..
    mainImgUpload(file) {

      //判断扩展名
      const tmpcnt = file.file.name.lastIndexOf(".");
      const exname = file.file.name.substring(tmpcnt + 1);
      // const names = ["jpg", "jpeg", "webp", "png", "bmp"];
      // if (names.indexOf(exname) < 0) {
      //   this.$message.error("不支持的格式!");
      //   return;
      // }
      const fileName = file.file.uid + "." + exname;
      client
        .put(fileName, file.file)
        .then((res) => {
          if (res.url) {
            this.formData.coverPlan = res.url;
          } else {
            this.$message.error("文件上传失败");
          }
        })
        .catch((err) => { });
    },


    // 获取
    getCourseClassifyList(superiorId) {
      this.loading = true;

      getCourseClassifyList({ type: 2, superiorId:superiorId,classifyType:1}).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.listData = res.data.list;
          return;
        }
        this.$message({
          type: "info",
          message: res.msg,
        });
      });
    },

    // 分页插件事件
    callFather(parm) {
      this.getDishesList(parm.currentPage);
    },

    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      if (row != undefined && row != "undefined") {
        this.title = "修改";
        this.formData.id = row.id;
        this.formData.coverPlan = row.coverPlan;
        this.formData.introduce = row.introduce;
        this.formData.title = row.title;
        this.formData.introduceOne = row.introduceOne;
        this.formData.titleOne = row.titleOne;
        this.formData.difficultyLevel = row.difficultyLevel;
        this.formData.superiorId = row.superiorId;
        this.formData.classifyType = 1;


        

      } else {
        this.title = "添加";
        this.formData.id = "";
        this.formData.coverPlan = "";
        this.formData.introduce = "";
        this.formData.title = "";
        this.formData.introduceOne = "";
        this.formData.titleOne = "";
        this.formData.difficultyLevel = 1;
        this.formData.superiorId = this.type3;
        this.formData.classifyType = 1;



        

      }
    },

    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}

.upload-demo {
  display: flex;
  flex-direction: row;
}

.upload-demo img {
  width: 140px;
  height: 140px;
}
</style>



// WEBPACK FOOTER //
// src/views/cooperationClassify/CourseFourClassify.vue